import { apiClient } from './client.js';

export const quizApi = {
  getQuizForTaking: (id) => apiClient.get(`/quizzes/${id}`),
  submitQuiz: (id, payload) => apiClient.post(`/quizzes/${id}/submit`, payload),
  getQuizHistory: (id) => apiClient.get(`/quizzes/${id}/history`),
};
